export default {
    loaded: 'user.loaded',
    game: 'user.game',
    balance: 'user.balance',
    pending_voucher: "user.pending_voucher",
    deposit_bonus: "user.deposit_bonus",
    update: "user.update",
    vip: {
        xp: 'user.vip.xp'
    },
    logins: {
        create: "user.logins.create",
        update: "user.logins.update",
        remove: "user.logins.remove"
    },
    // facebook_profile: {
    //     toggle: "user.facebook_profile.toggle.button",
    //     update: "user.facebook_profile.update"
    // },
    kyc_profile: {
        verification: "user.kyc_profile.verification",
        update: "user.kyc_profile.update"
    },
    promotions: {
        modals: {
            clear: "user.promotions.modals.clear",
            remove: "user.promotions.modals.remove"
        }
    },
    facebook: {
        toggle: "user.facebook.toggle.button",
        update: "user.facebook.update"
    },
    welcome_bonus: "user.welcome.bonus",
    logout: "user.logout"
}